import { defaultHeaders } from '@/config/defaultHeaders.ts'
import baseApiService from '@/core/services/baseApiService.ts'
import axios, { AxiosResponse } from 'axios'
import { appConfig } from '@/config/app.ts'
import { validateSchema } from '@/core/utils/safeSchemaValidations.ts'
import { baseResponseSchema } from '@/core/types/BaseResponse.ts'

const axiosInstance = axios.create({
  baseURL: `${appConfig.apiUrl}/${appConfig.apiVersion}`,
  headers: defaultHeaders
})

const unProtectedApiService = baseApiService(
  axiosInstance,
  (response: AxiosResponse) => {
    validateSchema(baseResponseSchema, response?.data)
    return response?.data?.data
  }
)

export default unProtectedApiService
